<template>
  <div class="pt-9">
    <v-row no-gutters align="center" justify="center">
      <v-col class="text-left" cols="12" sm="12" md="8">
        <v-form ref="form" lazy-validation>
          <div class="d-flex align-center">
            <div>
              <v-tooltip
                right
                content-class="arrow tooltip-right"
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="backLogin">
                    <v-icon large color="accent"
                      >icon-alertadis-angle-left-b</v-icon
                    >
                  </v-btn>
                </template>
                <span class="tooltip-text">Voltar para o login</span>
              </v-tooltip>
            </div>
            <div class="pl-2">
              <span
                :class="
                  $vuetify.breakpoint.smAndDown
                    ? 'title-style-mobile'
                    : 'title-style-tablet'
                "
                >Criar nova senha</span
              >
            </div>
          </div>
          <p
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'subtitle-style-mobile'
                : 'subtitle-style-tablet'
            "
          >
            Informe sua nova senha de acesso do AlertaDIS.
          </p>

          <div class="my-2 info-alert">
            <div class="d-flex">
              <div class="d-flex align-center">
                <v-icon color="primary darken-3"
                  >icon-alertadis-info-circle</v-icon
                >
              </div>
              <div class="pl-2 info-alert-text d-flex align-center">
                Você está usando a senha temporária, para sua segurança
                solicitamos que crie uma nova senha.
              </div>
            </div>
          </div>

          <div class="pt-2 form-input-group">
            <v-text-field
              class="text-field"
              id="password"
              color="accent lighten-1"
              background-color="trasnparent"
              v-model="password"
              :rules="[passwordRules]"
              outlined
              required
              prepend-inner-icon="icon-alertadis-padlock"
              :append-icon="passwordRules === true ? 'icon-alertadis-check' : ''"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Informe a senha"
            />
            <label for="password">Nova Senha</label>
          </div>
          <v-checkbox
            class="mt-1 check-form"
            color="accent lighten-1"
            v-model="showPassword"
            label="Mostrar a nova senha"
          />

          <div class="ml-3 my-3">
            <v-row>
              <v-icon :color="leastEightCharacters ? 'success' : 'primary'"
                >icon-alertadis-check</v-icon
              >
              <span class="ml-1 text-rules">Pelo menos 8 caracteres</span>
            </v-row>
            <v-row class="mt-5">
              <v-icon :color="leastOneUpperCase ? 'success' : 'primary'"
                >icon-alertadis-check</v-icon
              >
              <span class="ml-1 text-rules">Pelo menos 1 letra maiúscula</span>
            </v-row>
            <v-row class="mt-5">
              <v-icon :color="leastOneNumber ? 'success' : 'primary'"
                >icon-alertadis-check</v-icon
              >
              <span class="ml-1 text-rules">Pelo menos 1 número</span>
            </v-row>
            <v-row class="mt-5">
              <v-icon :color="leastOneSpecialChar ? 'success' : 'primary'"
                >icon-alertadis-check</v-icon
              >
              <span class="ml-1 text-rules"
                >Pelo menos 1 caractere especial</span
              >
            </v-row>
          </div>

          <v-row no-gutters align="center" class="pt-9">
            <v-col class="d-flex align-center">
              <v-btn
                class="btn-form"
                color="accent lighten-1"
                height="50"
                width="238"
                large
                :loading="loading"
                @click="newPasswordAndLogin"
              >
                <span>Salvar e acessar o AlertaDIS</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import routes from "../../router/routes";
import { snackbar } from "@/core/controller/snackbar_controller";
import UserService from "@/api/rest-administrative/user.service";
export default {
  name: "ForgotPassword",
  data: () => ({
    password: "",
    checkbox: false,
    loading: false,
    successAlert: false,
    showPassword: false,
  }),
  computed: {
    passwordRules() {
      if (!this.password) {
        return "Você precisa inserir sua nova senha.";
      }

      if (
        this.password.length < 8 ||
        !/[A-Z]/.test(this.password) ||
        !/[0-9]/.test(this.password) ||
        !/(?=.*[!@#$%^&*])/.test(this.password)
      ) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }

      return true;
    },
    leastEightCharacters() {
      return this.password.length >= 8;
    },
    leastOneUpperCase() {
      return /[A-Z]/.test(this.password);
    },
    leastOneNumber() {
      return /[0-9]/.test(this.password);
    },
    leastOneSpecialChar() {
      return /(?=.*[!@#$%^&*])/.test(this.password);
    },
  },
  methods: {
    async resetPassword() {
      if (this.$refs.form.validate()) {
        this.successAlert = true;
      }
    },
    async newPasswordAndLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch("updatePassword", {
            password: this.password,
          });
          const userInfo = await UserService.getCurrentUserinfo();
          this.$store.dispatch("logOut");
          await this.$store.dispatch("signIn", {
            email: userInfo.data.email,
            password: this.password,
          });
          snackbar.show({
            type: "success",
            title: "Senha alterada",
            message: "Senha alterada com sucesso!",
            timeout: 3000,
          });
        } catch (error) {
          snackbar.show({
            type: "error",
            title: error.name,
            message: error.message,
            timeout: 5000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
    backLogin() {
      this.$store.dispatch("logOut");
      this.$router.push(routes.login.path);
    },
  },
};
</script>

<style scoped>
label {
  order: -1;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.text-field {
  border-radius: 8px;
}

.btn-form {
  text-transform: none;
  border-radius: 8px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.check-form {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.form-input-group /deep/ .v-input__icon--append .v-icon {
  color: var(--v-success-base) !important;
}

.title-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.title-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.subtitle-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.subtitle-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.label-change-password {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1) !important;
}

.tooltip-right::before {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -6px;
  border-width: 6px;
  border-style: solid;
  border-top: solid 6px transparent;
  border-bottom: solid 6px transparent;
  border-left: solid 6px transparent;
}

.tooltip-right.arrow::before {
  border-right: solid 6px var(--v-secondary-lighten2) !important;
}

.tooltip-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}

.info-alert {
  padding: 5px;
  border-radius: 8px;
  color: var(--v-primary-darken3);
  background-color: var(--v-primary-base) !important;
}

.info-alert-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.text-rules {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

/* .v-text-field--outlined /deep/ .v-input__control /deep/ .v-input__slot {
      background: #ffffff !important;
  } */
</style>
